import React, { CSSProperties } from "react";
import styled from "styled-components";

export enum IconType {
  UStorkBeta = "ustork/beta",
  ArrowRightLong = "arrow/right/long",
  Image = "image",
  Cross = "cross",
}

const _icons: Record<IconType, JSX.Element> = {
  [IconType.UStorkBeta]: (
    <svg
      width='1em'
      height='1em'
      viewBox='0 0 133 31'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M117.389 1.31c0 .415-.312.72-.776.72s-.776-.305-.776-.697c0-.392.312-.696.776-.696s.776.288.776.672zm-.152 1.32v4.303h-1.248V2.63h1.248zm4.295.455V.997h1.248v5.936h-1.192v-.496c-.312.376-.768.56-1.344.56-1.216 0-2.152-.864-2.152-2.216 0-1.352.936-2.216 2.152-2.216.528 0 .976.168 1.288.52zm-2.176 1.696c0 .744.48 1.192 1.104 1.192.616 0 1.096-.448 1.096-1.192s-.48-1.192-1.096-1.192c-.624 0-1.104.448-1.104 1.192zm8.795.016c0-1.384-.976-2.232-2.24-2.232-1.312 0-2.296.928-2.296 2.216 0 1.28.968 2.216 2.456 2.216.776 0 1.376-.24 1.776-.696l-.664-.72c-.296.28-.624.416-1.08.416-.656 0-1.112-.328-1.232-.864h3.256l.008-.095v-.002c.008-.083.016-.17.016-.239zm-2.232-1.288c.56 0 .968.352 1.056.896h-2.12c.088-.552.496-.896 1.064-.896zm2.825-.424c.472-.336 1.168-.52 1.856-.52 1.312 0 2.072.608 2.072 1.912v2.456h-1.168v-.536c-.232.392-.68.6-1.312.6-1.008 0-1.608-.56-1.608-1.304 0-.76.536-1.288 1.848-1.288h.992c0-.536-.32-.848-.992-.848-.456 0-.928.152-1.24.4l-.448-.872zm1.056 2.552c0 .312.264.52.704.52.416 0 .776-.192.92-.584v-.44h-.856c-.584 0-.768.216-.768.504zM64.464 10c-2.985 0-5.543 1.014-7.675 3.066-2.11 2.029-3.165 4.494-3.165 7.434 0 2.94 1.054 5.432 3.136 7.46 2.108 2.026 4.671 3.04 7.652 3.04 2.98 0 5.539-1.014 7.622-3.066 2.111-2.052 3.166-4.577 3.166-7.512 0-2.936-1.053-5.407-3.139-7.408-2.085-2-4.612-3.014-7.597-3.014zm-3.96 14.503a5.76 5.76 0 01-1.583-4.03h.004a5.651 5.651 0 011.58-4 5.298 5.298 0 011.771-1.25 5.368 5.368 0 014.264 0 5.299 5.299 0 011.772 1.25 5.651 5.651 0 011.583 4 5.76 5.76 0 01-1.583 4.03c-.496.532-1.1.957-1.772 1.248a5.368 5.368 0 01-4.264 0 5.298 5.298 0 01-1.772-1.248zm-46.848 2.312a2.922 2.922 0 00-.219 1.183h.009a2.8 2.8 0 00.502 1.647c-1.368.875-3.166 1.342-5.401 1.342C2.77 30.987 0 27.765 0 22.67V10.35h5.25v12.243c0 2.156 1.133 3.612 3.35 3.612 2.4 0 3.376-1.508 3.376-3.508V10.35h5.24v12.243c.003.789-.073 1.576-.227 2.35a3.505 3.505 0 00-.491-.039 2.993 2.993 0 00-1.178.234 2.955 2.955 0 00-.986.676 2.958 2.958 0 00-.678 1zm13.948 4.172c2.506 0 4.458-.597 5.856-1.793h.009c1.397-1.196 2.083-2.729 2.083-4.575 0-1.658-.606-2.963-1.793-3.898-1.187-.962-3.086-1.82-5.724-2.573-2.19-.624-2.797-1.222-2.797-2.079 0-1.015.924-1.715 2.215-1.715 1.66 0 2.823.805 3.508 2.416l4.249-2.287c-1.161-2.702-3.826-4.47-7.624-4.47-2.084 0-3.852.597-5.329 1.793a5.655 5.655 0 00-1.638 2.02 5.569 5.569 0 00-.55 2.529c0 3.404 2.373 5.25 7.015 6.497 2.453.65 3.218 1.17 3.218 2.079 0 1.04-1.002 1.69-2.664 1.69-1.978 0-3.35-.832-4.115-2.495l-4.305 2.183c1.343 3.119 4.138 4.678 8.386 4.678zm8.925-15.983h5.856v15.698h5.2V15.004h5.827V10.35H36.529v4.654zm40.73 15.698h5.198v-7.149h1.687l4.142 7.154h5.646l-4.59-7.926c2.454-.864 4.115-2.761 4.115-5.88 0-2.158-.713-3.77-2.11-4.888-1.398-1.117-3.271-1.663-5.62-1.663H77.26v20.352zm8.074-11.515h-2.876l.006-4.413h2.843c2.03 0 2.928.935 2.928 2.313 0 1.347-1.03 2.1-2.901 2.1zm10.445-8.837v20.352H101v-9.643l6.538 9.643H114l-7.597-10.682 7.095-9.67h-6.112l-6.384 8.733V10.35h-5.224z'
        fill='#000'
      />
    </svg>
  ),
  [IconType.ArrowRightLong]: (
    <svg
      width='1em'
      height='1em'
      viewBox='0 0 36 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M25.11 3.991a1.5 1.5 0 10-2.22 2.018l7.72 8.491H2a1.5 1.5 0 000 3h28.61l-7.72 8.491a1.5 1.5 0 102.22 2.018l10-11a1.5 1.5 0 000-2.018l-10-11z'
        fill='#000'
      />
    </svg>
  ),
  [IconType.Image]: (
    <svg
      width='1em'
      height='1em'
      viewBox='0 0 32 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M28 6H4a2 2 0 00-2 2v10.857l3.185-3.64a4 4 0 015.838-.194L18 22l2.354-2.354a4 4 0 015.462-.182L30 23.125V8a2 2 0 00-2-2zM4 4a4 4 0 00-4 4v16a4 4 0 004 4h24a4 4 0 004-4V8a4 4 0 00-4-4H4zm19 10a3 3 0 100-6 3 3 0 000 6z'
        fill='#000'
      />
    </svg>
  ),
  [IconType.Cross]: (
    <svg
      width='1em'
      height='1em'
      viewBox='0 0 32 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M7.06 4.94a1.5 1.5 0 10-2.12 2.12L13.878 16l-8.94 8.94a1.5 1.5 0 002.122 2.12L16 18.122l8.94 8.94a1.5 1.5 0 002.12-2.122L18.122 16l8.94-8.94a1.5 1.5 0 00-2.122-2.12L16 13.878l-8.94-8.94z'
        fill='#000'
      />
    </svg>
  ),
};

interface IconDivProps {
  height: CSSProperties["height"];
  width: CSSProperties["width"];
  size: CSSProperties["width"];
  opacity: CSSProperties["opacity"];
  filter: CSSProperties["filter"];
  color: CSSProperties["color"];
  isHover: boolean;
}
const IconDiv = styled.div<IconDivProps>`
  display: flex;
  justify-items: center;
  align-items: center;
  transition: all 0.35s ease-in-out;
  user-select: none;
  -webkit-user-drag: none;

  height: ${({ height, size }) => height || size};
  width: ${({ width, size }) => width || size};
  min-width: ${({ width, size }) => width || size};
  opacity: ${({ opacity }) => opacity || "100%"};
  filter: ${({ filter }) => filter};

  & path {
    fill: ${({ color }) => color ?? ""};
  }

  & svg {
    width: 100%;
    height: 100%;

    &:hover {
      cursor: ${({ isHover }) => (isHover ? "pointer" : "default")};
    }
  }
`;

export enum IconColor {
  White = "white",
  Dark = "dark",
  Accent = "accent",
}

export interface IconProps {
  type: IconType;
  color?: IconColor;
  className?: string | undefined;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  height?: CSSProperties["height"];
  width?: CSSProperties["width"];
  size?: CSSProperties["width"];
  opacity?: CSSProperties["opacity"];
  isIgnoreSchema?: boolean;
  style?: CSSProperties;
}

const Icon: React.VFC<IconProps> = ({
  type,
  color = IconColor.Dark,
  className = "",
  onClick,
  height = undefined,
  width = undefined,
  size,
  opacity = undefined,
  style = {},
}) => {
  const _themedProps: Record<IconColor, CSSProperties> = {
    [IconColor.White]: { filter: "invert(1)" },
    [IconColor.Dark]: { filter: "" },
    [IconColor.Accent]: { color: "#ffcc00" },
  };

  const _props = _themedProps[color];

  return (
    <IconDiv
      isHover={!!onClick}
      height={height}
      width={width}
      size={size}
      opacity={opacity}
      filter={_props.filter}
      color={_props.color}
      style={style ?? {}}
      onClick={(e) => {
        e?.preventDefault();
        if (onClick) {
          onClick(e);
        }
      }}
      className={`${className ?? ""}`}>
      {_icons[type]}
    </IconDiv>
  );
};

export default Icon;
